import { fileOpenMethod } from '@convenia/helpers'

const getFileName = (name, extension) => {
  const safeName = name || ''

  return !safeName.includes('.') && extension
    ? safeName + '.' + extension
    : safeName
}

export const mapFiles = (files, params) => {
  const { employeeId, getFileUrl } = params || {}

  return (files || []).map(({ id, fileName, extension, size }) => ({
    id,
    size,
    url: () => getFileUrl(id, employeeId),
    name: getFileName(fileName, extension),
    preview: () => getFileUrl(id, employeeId),
    openMethod: fileOpenMethod,
  }))
}
